export const GET_SUBSCRIPTIONS_ATTEMPT = 'GET_SUBSCRIPTIONS_ATTEMPT';
export const GET_SUBSCRIPTIONS_SUCCESS = 'GET_SUBSCRIPTIONS_SUCCESS';
export const GET_SUBSCRIPTIONS_FAILURE = 'GET_SUBSCRIPTIONS_FAILURE';

export const GET_SUBSCRIPTIONS_ATTEMPT_FOR_ACCOUNT = 'GET_SUBSCRIPTIONS_ATTEMPT_FOR_ACCOUNT';
export const GET_SUBSCRIPTIONS_SUCCESS_FOR_ACCOUNT = 'GET_SUBSCRIPTIONS_SUCCESS_FOR_ACCOUNT';
export const GET_SUBSCRIPTIONS_FAILURE_FOR_ACCOUNT = 'GET_SUBSCRIPTIONS_FAILURE_FOR_ACCOUNT';

export const CLEAR_SUBSCRIPTIONS_LIST = 'CLEAR_SUBSCRIPTIONS_LIST';
export const SET_SELECTED_SUBSCRIPTION = 'SET_SELECTED_SUBSCRIPTION';
export const SET_SEARCH_PARAMETERS = 'SET_SEARCH_PARAMETERS';
export const CLEAR_STATE = 'CLEAR_STATE';
